module.exports = __webpack_public_path__ + "static/ap-26e0d75f232404895fc3720e322ea52d.jpg";